import { Box, Typography } from "@mui/material";
import React from "react";
import { getResponsiveSize } from "../../utils/responsive";
import globalStyles from "../../global";
import { useTranslation } from "react-i18next";

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const EventBanner = ({ slides }) => {
  const { t } = useTranslation();
  return (
    <Box sx={styles.mainBox}>
      <Box sx={styles.innerBox}>
        <Box sx={styles.rightBox}>
          <Box sx={styles.titleWrapper}>
            <Typography variant="title_banner">
              {t("event.topContainerTitle")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainBox: {
    height: {
      xs: "280px", // mobile
      sm: "440px", // tablets
      md: "500px", // laptops/desktops
    },
    width: "100%",
    py: { xs: 2, sm: 6 },
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden",
    display: "flex",
    backgroundImage: `url(${imageBaseUrl}ContactBanner.svg)`,
  },
  innerBox: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  rightBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: { xs: getResponsiveSize(4), md: 10 },
    marginBottom: { xs: getResponsiveSize(8), md: 10 },
    width: {
      xs: "90%",
      md: "80%",
    },
  },

  titleWrapper: {
    width: "100%",
    textAlign: "center",
    mb: { xs: 2, sm: 3 },
  },

  title: {
    color: "white",
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 800,
    lineHeight: 1.1,
    textAlign: "center",
    fontSize: {
      xs: getResponsiveSize(40), // Reduced font size for mobile
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
  },
  titleSpan: {
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 800,
    display: "inline",
    textAlign: "left",
    color: "white",
    fontSize: {
      xs: getResponsiveSize(40), // Reduced font size for mobile
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
  },

  subTitleWrapper: {
    width: "100%",
    textAlign: "center",
    mb: { xs: 3, sm: 4 },
  },

  subTitle: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(16),
      md: getResponsiveSize(18),
    },
    color: "#666",
    lineHeight: 1.4,
  },
  subTitleBold: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(20),
      md: getResponsiveSize(24),
    },
    color: globalStyles.colors.white,
  },

  infoStack: {
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: {
      xs: "center", // Center on mobile
      sm: "space-evenly",
    },
    alignItems: "center",
    mb: { xs: 3, sm: 4 },
    rowGap: { xs: 2, sm: 0 },
    // Make sure the stack takes up full width on mobile
    width: { xs: "100%", sm: "auto" },
  },

  infoItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // Make sure each info item takes up full width on mobile
    width: {
      xs: "100%",
      sm: "auto", // Let it shrink or grow as needed on larger screens
    },
    // Add horizontal padding on mobile so text isn't too close to edges
    px: { xs: 2, sm: 0 },
  },

  infoText: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    color: globalStyles.colors.white,
    ml: "4px",
    fontSize: {
      xs: getResponsiveSize(12), // Reduced font size for mobile
      sm: getResponsiveSize(16),
      md: getResponsiveSize(18),
    },
    textAlign: "left",
    // Add text wrapping on mobile
    whiteSpace: { xs: "normal", sm: "nowrap" },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mb: 4,
  },

  registerButton: {
    borderRadius: "10px",
    backgroundColor: globalStyles.colors.uclean_green,
    color: globalStyles.colors.white || "#ffffff",
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(16),
      md: getResponsiveSize(18),
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    px: 4,
    py: 1.5,
    minWidth: {
      xs: "180px",
      md: "200px",
    },
    "&:hover": {
      color: globalStyles.colors.white || "#ffffff",
      backgroundColor: globalStyles.colors.army_green || "#4caf50",
      transform: "translateY(-2px)",
    },
  },
};

export default EventBanner;
